import { mainSiteUrl } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function CTABanner() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20top-down%20view%20of%20a%20beautifully%20organized%20minimalist%20workspace%20with%20multiple%20laptops%20and%20tablets%20displaying%20spreadsheet%20data%2C%20surrounded%20by%20elegant%20fashion%20accessories%20and%20textiles%20artfully%20arranged%2C%20warm%20cream%20background%2C%20soft%20natural%20sunlight%2C%20clean%20editorial%20composition%2C%20luxurious%20aesthetic%2C%20harmonious%20warm%20tones&width=1800&height=800&seq=cta-mulebuy-banner&orientation=landscape"
          alt="Mulebuy Spreadsheet platform and products styled elegantly"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/30 to-black/45"></div>
      </div>

      <div className="relative z-10 container-custom">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="max-w-xl">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight">
              Smarter sourcing<br />starts here
            </h2>
            <p className="text-sm md:text-base text-background-100/70 mt-4 max-w-md leading-relaxed">
              Compare systems, track orders, and scale your business with data-driven Mulebuy Spreadsheet workflows.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Link
              to="/what-is-mulebuy-spreadsheet"
              className="w-full sm:w-auto px-7 py-3.5 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm font-semibold rounded-md hover:bg-background-50/25 transition-all whitespace-nowrap font-label flex items-center justify-center gap-2"
            >
              Explore Guides
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-7 py-3.5 bg-accent-500 text-background-50 text-sm font-semibold rounded-md hover:bg-accent-600 transition-all whitespace-nowrap font-label flex items-center justify-center gap-2 group"
            >
              Visit Main Platform
              <span className="w-5 h-5 flex items-center justify-center bg-background-50/20 rounded-full group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}